// FF Cleanup: amenities-data-tabs - this component will no longer be used anywhere
import { useTranslation } from 'react-i18next';
import Uploader from './Uploader';

const CsvUploader = props => {
  const { t } = useTranslation('common');
  return (
    <Uploader
      {...props}
      accept=".csv"
      helpText={t('csvOnly')}
      errorMessage={t('csvUploadFailure')}
    />
  );
};

export default CsvUploader;
